import { RouteConfig } from "vue-router";

const facturas: RouteConfig = {
  path: "/facturas",
  name: "facturas",
  component: () => import(/* webpackChunkName: "facturas" */ "@/views/Facturas.vue"),
};

export default facturas;
